/** Blocking needs a signed-in viewer and a known creator; creators cannot block themselves. */
export default function canBlockCharacterCreator({ character, onlyUserId }) {
    if (character === null || !onlyUserId) {
        return false;
    }
    return Boolean(character.creator_user_id) && character.creator_user_id !== onlyUserId;
}
